import React from 'react';
import PropTypes from 'prop-types';

import svg from './library';

export default function Icon({ color, name }) {
  const IconSvg = svg[name];
  return <IconSvg color={color} />;
}

Icon.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string.isRequired,
};

Icon.defaultProps = {
  color: '#595959',
};
